import React, { useState, createContext, FC, useContext, ReactNode, useEffect } from 'react';

import { ContextProps, initialContext } from './modules';
import { optionTypes } from 'src/helpers';

const MainContext = createContext<ContextProps>(initialContext)

const MainContextProvider: FC<{
    children: ReactNode
}> = ({ children }) => {

    const [formData, setformData] = useState<any>(undefined)
    const [apiRespData, setapiRespData] = useState<any>(undefined)
    const [showFormDialog, setshowFormDialog] = useState<boolean>(false)

    useEffect(() => {
        if (!apiRespData) {
            setshowFormDialog(true)
        }
        return () => { }
    }, [])


    const updateFormData = (e: any) => {
        setformData(e)
    }

    const updateApiRespData = (e: any) => {
        setapiRespData(e)
    }

    const updateShowFromDialog = (e: any) => {
        setshowFormDialog(e)
    }

    return (
        <MainContext.Provider value={{ formData, apiRespData, showFormDialog, updateFormData, updateShowFromDialog, updateApiRespData }}>
            {children}
        </MainContext.Provider>
    )
}

const useMainContext = () => useContext(MainContext)
export { MainContextProvider, useMainContext }